"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
/**
 * Returns the first valid email from string.
 * Used to get email from Acsel
 *
 * @param emailList - The email list getting from Acsel
 */
function getMostRecentValidEmail(emailList) {
    if (emailList === null || typeof emailList === 'undefined') {
        return '';
    }
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    var emailArray = emailList.match(constants_1.emailRegex);
    if (emailArray) {
        return emailArray[emailArray.length - 1];
    }
    return '';
}
exports.default = getMostRecentValidEmail;
//# sourceMappingURL=getMostRecentValidEmail.js.map